<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Desarrollo Web</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Sitios y plataformas diseñados para <span class="highlight-green">convertir</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Creamos experiencias digitales a medida, optimizadas para rendimiento, posicionamiento y conversión.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Sitios web responsivos y modernos</li>
          <li><i class="bi bi-check-circle-fill"></i> Optimización SEO y rendimiento</li>
          <li><i class="bi bi-check-circle-fill"></i> Mantenimiento continuo y soporte</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-laptop"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="fa fa-globe"></i>
          </div>
          <h4 class="modern-service-card-title">Sitios Web</h4>
          <p>Creamos sitios modernos, responsivos y optimizados para convertir visitantes en clientes.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-window-stack"></i>
          </div>
          <h4 class="modern-service-card-title">Plataformas Digitales</h4>
          <p>Desarrollamos plataformas escalables adaptadas a las necesidades específicas de tu negocio.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-tools"></i>
          </div>
          <h4 class="modern-service-card-title">Mantenimiento Continuo</h4>
          <p>Aseguramos que tu sitio funcione de forma óptima con actualizaciones, soporte y mejoras constantes.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Enfoque personalizado para cada proyecto
          </li>
          <li><i class="bi bi-check-circle-fill"></i> Transparencia y comunicación abierta</li>
          <li><i class="bi bi-check-circle-fill"></i> Experiencia comprobada en diversas
            industrias</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Construyamos una experiencia digital que trabaje para tu negocio.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
